/* @flow */
import * as React from 'react';

import Group from 'entities/Group';
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';
import MediaObject from 'components/MediaObject';
import RestoreClassConfirmDialog from 'groups/components/RestoreClassConfirmDialog';
import ReuseClassConfirmDialog from 'groups/components/ReuseClassConfirmDialog';
import Time from 'components/Time';
import MenuButton from 'components/MenuButton';
import Glyph from 'components/Glyph';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import { mountModal } from 'lib/modal';
import Icon from 'components/Icon';
import Button from 'components/Button';

import './styles/ArchivedClassesListItem.scss';

export class ArchivedClassesListItem extends React.Component<{
  archivedClass: Group,
  canCreateGroups: boolean,
  onActionCompletion: () => void,
}> {
  renderMenu() {
    return (
      <Menu>
        <MenuItem onClick={this.showRestoreClassModal}>
          <Icon
            className="ArchivedClassesListItem-menuItem-icon"
            name="arrow-up-bar"
            size="medium"
            color="eclipse"
          />
          Restore class
        </MenuItem>
        <MenuItem onClick={this.showReuseClassModal}>
          <Icon
            className="ArchivedClassesListItem-menuItem-icon"
            name="circle-arrows"
            size="medium"
            color="eclipse"
          />
          Reuse class code
        </MenuItem>
      </Menu>
    );
  }

  showReuseClassModal = () => {
    const { archivedClass, onActionCompletion } = this.props;
    const unmountModal = mountModal(
      <ReuseClassConfirmDialog
        group={archivedClass}
        subText={`A new class will be created with the code @${archivedClass.getCodeOrError()}, and this class will be archived with an automatically generated code.`}
        onActionCompletion={() => {
          if (onActionCompletion) {
            onActionCompletion();
          }
          if (unmountModal) {
            unmountModal();
          }
        }}
      />,
      this
    );
  };

  showRestoreClassModal = () => {
    const { archivedClass, onActionCompletion } = this.props;
    const unmountModal = mountModal(
      <RestoreClassConfirmDialog
        group={archivedClass}
        onActionCompletion={() => {
          if (onActionCompletion) {
            onActionCompletion();
          }
          if (unmountModal) {
            unmountModal();
          }
        }}
      />,
      this
    );
  };

  render() {
    const { archivedClass, canCreateGroups } = this.props;

    return (
      <MediaObject center figure="right" gutter="xsmall" className="ArchivedClassesListItem">
        <GroupAvatarWithText
          group={archivedClass}
          subtextAppend={
            <Time
              date={archivedClass.getArchivedDate()}
              month="numeric"
              day="numeric"
              year="numeric"
            />
          }
        />
        <div className="ArchivedClassesListItem-actions">
          {archivedClass.hasRosterSource() && (
            <Button
              aria-label="Linked Remind classes are updated directly from your school’s database."
              className="ArchivedClassesListItem-link"
              tooltip="Linked Remind classes are updated directly from your school’s database."
              tooltipPlacement="top"
              color="shamrock"
              level="icon">
              <Glyph name="link" size="large" />
            </Button>
          )}
          {canCreateGroups && (
            <MenuButton
              className="ArchivedClassesListItem-menuButton"
              alignment="right"
              placement="bottom"
              menu={this.renderMenu()}
              size="small"
              level="icon">
              <Glyph name="ellipses" size="large" solo />
            </MenuButton>
          )}
        </div>
      </MediaObject>
    );
  }
}

export default ArchivedClassesListItem;
